import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export const getEnderecoByCep = async (cep: string) => {
  const url = `${API_CONSTANT_MAP.cep}/${cep}`;
  return requestApi.get(url);
};
